import { changeParadeId, programmaticWallpaper } from "./custom-needs";

function wallpaperStyles(isProgrammaticWallpaper?: boolean): void {
  // Run only once, as the programmatic reloads almad-wallpaper-1
  if (window.programmaticWallpaper) return;

  let css = "";
  if (isProgrammaticWallpaper) {
    css =
      "body{padding-top:44px;}#almad-wallpaper-1{width:1600px;height:1150px;position:fixed;left:50%;margin-left:-816px; top: 0;}#almad-wallpaper-1 > div {margin: 0;}#almad-parade-1 > div {position: relative;}@media screen and (min-width:1160px){.container,.wallpaper-parade-ad-container{max-width:980px;}.container,.wallpaper-parade-ad-container{right:90px;}}@media screen and (min-width:1280px){.container{right:150px;}}@media screen and (max-width:1280px){#almad-wallpaper-1{margin-left:-756px;}}@media screen and (max-width:1160px){#almad-wallpaper-1{margin-left:-666px;}}.skyscraper-ad-container{position:absolute;}";
    // var css = 'body{padding-top:44px;}#almad-wallpaper-1{width:1600px;height:1150px;position:fixed;left:50%;margin-left:-817px; top: 0;}#almad-wallpaper-1 > div {margin: 0;}#almad-parade-1 > div {position: relative;z-index:1;}@media screen and (min-width:1160px){.container,.wallpaper-parade-ad-container{max-width:980px;}.container,.wallpaper-parade-ad-container{right:90px;}}@media screen and (min-width:1280px){.container{right:150px;}}@media screen and (max-width:1280px){#almad-wallpaper-1{margin-left:-756px;}}@media screen and (max-width:1160px){#almad-wallpaper-1{margin-left:-666px;}}.skyscraper-ad-container{position:absolute;}';
  } else {
    css =
      "#almad-wallpaper-1{width:1600px;height:1200px;position:fixed;left:50%;margin-left:-816px; top: 0;}#almad-wallpaper-1 > div {margin: 0;}#almad-parade-1 > div {position: relative;z-index:1;}@media screen and (min-width:1160px){.container,.wallpaper-parade-ad-container{max-width:980px;}.container,.wallpaper-parade-ad-container,#almad-parade-1 > div{right:90px;}}@media screen and (min-width:1280px){.container,#almad-parade-1 > div{right:150px;}}@media screen and (max-width:1280px){#almad-wallpaper-1{margin-left:-756px;}}@media screen and (max-width:1160px){#almad-wallpaper-1{margin-left:-666px;}}.skyscraper-ad-container{position:absolute;}";
  }

  const head = document.head || document.getElementsByTagName("head")[0];
  const style = document.createElement("style") as any;

  style.type = "text/css";
  style.id = "wallpaper-ad-styles";
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }

  head.appendChild(style);

  if (isProgrammaticWallpaper) {
    programmaticWallpaper();
  } else {
    changeParadeId();
  }
}

function removeWallpaperStyles(): void {
  if (document.getElementsByTagName("body")[0].hasAttribute("style")) {
    document.getElementsByTagName("body")[0].removeAttribute("style");
  }

  if (document.getElementById("wallpaper-ad-styles")) {
    const wallpaperStylesElement = document.getElementById(
      "wallpaper-ad-styles"
    );
    if (wallpaperStylesElement && wallpaperStylesElement.parentNode) {
      wallpaperStylesElement.parentNode.removeChild(wallpaperStylesElement);
    }
  }
}

function smokeScreenStyles(): void {
  const css =
    "#smokeScreen1 {position:fixed; top: 0; left: 0; background-color: #000; height:100%; width:100%; z-index:1500; opacity:0.6; filter:alpha(opacity=60); /* For IE8 and earlier */ }#interstitialContainer { display:none; position:fixed; top:30px; left:0; height:100%; width:100%; z-index:2001;}#interstitialClose {width: 956px;height: 35px;margin-left: auto;margin-right: auto;margin-top: 20px;}#interstitialClose a {float: right;width: 73px;height: 30px;border: none;background: url(https://static.ilcdn.fi/kuvat/mainokset/smokescreen_close_73x24.png) no-repeat;}#interstitialCreative {position:relative; background-color:white; width:956px; height:586px; margin-left:auto; margin-right:auto; }";
  const head = document.head || document.getElementsByTagName("head")[0];
  const style = document.createElement("style") as any;

  style.type = "text/css";
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }

  head.appendChild(style);
}

function paradeStyles(height: string): void {
  const paradeE = document.getElementById("almad-parade-1");
  if (paradeE) {
    paradeE.style.height = height;
  }
}

const setCeltraParadeStyles = function() {
 
  const css = '.celtra-ad-host {z-index:10001 !important;} #almad-parade-1 .celtra-ad-host {position:relative;} .celtra-ad-inline-host {z-index:10001 !important;} #almad-parade-1 .celtra-ad-inline-host {position:relative;}';
  const head = document.head || document.getElementsByTagName('head')[0];
  const style = document.createElement("style") as any;

  style.type = 'text/css';
  style.id = 'il-celtra-styles';
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }

  head.appendChild(style);

};
if (!window.document.getElementById("il-celtra-styles")) setCeltraParadeStyles();

export {
  wallpaperStyles,
  removeWallpaperStyles,
  smokeScreenStyles,
  paradeStyles,
  setCeltraParadeStyles,
};
